import React from 'react';

import { H6Typography } from '../../Typography';

import theme from '$/assets/theme';

const Title: React.FC<{ disabled?: boolean; style?: React.CSSProperties }> = (
  props
) => (
  <H6Typography
    bold
    as="p"
    style={{
      margin: '32px 8px 16px',
      color: theme.colors.grey7,
      opacity: props.disabled ? 0.7 : null,
      ...(props.style ?? {}),
    }}
  >
    {props.children}
  </H6Typography>
);

export default Title;
